import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { Box, Chip, IconButton, Switch, Tooltip } from "@mui/material";
import moment from "moment";

export function getColumns({ onToggleEnabled, onToggleRoundRobin, onExecuteClick }) {
    return [
        {
            field: "roundRobin",
            headerName: "Continuous",
            width: 110,
            renderCell: (params) => (
                <Box onClick={(e) => e.stopPropagation()}>
                    <Switch
                        checked={params.row.exhausted ? false : Boolean(params.value)}
                        size="small"
                        disabled={Boolean(params.row.exhausted)}
                        onChange={(e) => onToggleRoundRobin(params.row, e.target.checked)}
                    />
                </Box>
            )
        },
        {
            field: "enabled",
            headerName: "Enabled",
            width: 100,
            renderCell: (params) => (
                <Box onClick={(e) => e.stopPropagation()}>
                    <Switch
                        checked={params.value || false}
                        size="small"
                        onChange={(e) => onToggleEnabled(params.row, e.target.checked)}
                    />
                </Box>
            )
        },
        {
            field: "exhausted",
            headerName: "Exhausted",
            width: 110,
            renderCell: (params) => {
                const exhausted = Boolean(params.value);
                const at = params.row.exhaustedAt;
                const chip = (
                    <Chip
                        label={exhausted ? "Yes" : "No"}
                        size="small"
                        color={exhausted ? "warning" : "default"}
                        variant={exhausted ? "filled" : "outlined"}
                    />
                );
                if (exhausted && at) {
                    return (
                        <Tooltip title={`Since ${moment(at).format("YYYY-MM-DD HH:mm")}`}>
                            {chip}
                        </Tooltip>
                    );
                }
                return chip;
            }
        },
        {
            field: "title",
            headerName: "Title",
            flex: 1,
            minWidth: 200
        },
        {
            field: "tags",
            headerName: "Tags",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => {
                const tags = Array.isArray(params.value) ? params.value : [];
                return (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, alignItems: "center", height: "100%", py: 0.5 }}>
                        {tags.map((tag, index) => (
                            <Chip key={`${tag}-${index}`} label={tag} size="small" variant="outlined" />
                        ))}
                    </Box>
                );
            }
        },
        {
            field: "createdAt",
            headerName: "Created at",
            width: 160,
            valueFormatter: (value) => {
                if (value == null || value === undefined) return "";
                return moment(value).format("YYYY-MM-DD HH:mm");
            }
        },
        {
            field: "latestGenDate",
            headerName: "Latest Gen",
            width: 160,
            valueFormatter: (value) => {
                if (value == null || value === undefined) return "";
                return moment(value).format("YYYY-MM-DD HH:mm");
            }
        },
        {
            field: "gridPuzzlesCreated",
            headerName: "Grid",
            width: 80,
            type: "number",
            valueGetter: (value) => (value != null ? value : 0),
            sortable: false
        },
        {
            field: "crosswordPuzzlesCreated",
            headerName: "Crossword",
            width: 100,
            type: "number",
            valueGetter: (value) => (value != null ? value : 0),
            sortable: false
        },
        {
            field: "wordWheelPuzzlesCreated",
            headerName: "Word Wheel",
            width: 110,
            type: "number",
            valueGetter: (value) => (value != null ? value : 0),
            sortable: false
        },
        {
            field: "standaloneImagesCreated",
            headerName: "Images",
            width: 90,
            type: "number",
            valueGetter: (value) => (value != null ? value : 0),
            sortable: false
        },
        {
            field: "imagesRejected",
            headerName: "Rejected",
            width: 110,
            type: "number",
            valueGetter: (value) => (value != null ? value : 0),
            renderCell: (params) => {
                const rejected = Number(params.value) || 0;
                const created = Number(params.row.standaloneImagesCreated) || 0;
                const rate = created > 0 ? rejected / created : 0;
                let color = "default";
                if (rejected > 0 && rate >= 0.5) {
                    color = "error";
                } else if (rejected > 0 && rate >= 0.25) {
                    color = "warning";
                }
                const pct = created > 0 ? Math.round(rate * 100) : 0;
                const title = created > 0
                    ? `Deleted or disabled standalone images (${pct}% of ${created} created)`
                    : "Deleted or disabled standalone images";
                return (
                    <Tooltip title={title}>
                        <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
                            <Chip
                                label={rejected}
                                size="small"
                                color={color}
                                variant={rejected > 0 ? "filled" : "outlined"}
                            />
                        </Box>
                    </Tooltip>
                );
            }
        },
        {
            field: "genWordWheel",
            headerName: "WW",
            width: 60,
            sortable: false,
            renderCell: (params) => (params.value ? "✓" : "")
        },
        {
            field: "genStandaloneImage",
            headerName: "Img",
            width: 60,
            sortable: false,
            renderCell: (params) => (params.value ? "✓" : "")
        },
        {
            field: "genWordSearch9",
            headerName: "Mini",
            width: 70,
            sortable: false,
            renderCell: (params) => (params.value ? "✓" : "")
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 80,
            sortable: false,
            renderCell: (params) => (
                <Box onClick={(e) => e.stopPropagation()}>
                    <Tooltip title="Execute">
                        <IconButton
                            size="small"
                            color="success"
                            onClick={() => onExecuteClick(params.row)}
                        >
                            <PlayArrowIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
            )
        }
    ];
}
